import { render, staticRenderFns } from "./c-slider.vue?vue&type=template&id=15e08dc1&scoped=true"
import script from "./c-slider.vue?vue&type=script&lang=js"
export * from "./c-slider.vue?vue&type=script&lang=js"
import style0 from "./c-slider.vue?vue&type=style&index=0&id=15e08dc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e08dc1",
  null
  
)

export default component.exports